module.exports = __webpack_public_path__ + "img/bm.bf9deb95.jpg";